import { createContext, useContext } from "react";
import { jsx } from "react/jsx-runtime";
//#region src/index.tsx
function createSsrCollector() {
	return {
		styles: /* @__PURE__ */ new Map(),
		headElements: /* @__PURE__ */ new Map()
	};
}
var SsrCollectorContext = createContext(null);
function SsrCollectorProvider({ collector, children }) {
	return /* @__PURE__ */ jsx(SsrCollectorContext.Provider, {
		value: collector,
		children
	});
}
function useSsrCollector() {
	return useContext(SsrCollectorContext);
}
//#endregion
export { SsrCollectorProvider, createSsrCollector, useSsrCollector };
